import React from "react"
import HomeApp from "../home/HomeApp"

// App Detail (doc 04) — same metrics UI as Partner Home, scoped to one app by
// the metricsPath the shell view points at (Partners::DashboardMetrics with
// partner_app: set). Adds a "back to apps" link above the shared shell.
export default function AppDetailApp({ metricsPath, settingsPath, appsPath, backLabel, copy }) {
  return (
    <div>
      <a
        href={appsPath}
        className="mb-4 inline-flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
      >
        ← {backLabel}
      </a>
      <HomeApp metricsPath={metricsPath} settingsPath={settingsPath} copy={copy} />
    </div>
  )
}
